import { LitElement, html, css } from 'lit';
import { accessibility, grid, details } from '../../utilities/styles';
import { cardLinks } from '../../utilities/accessibility';
import { EventManager } from '../../utilities/events';
import { cache } from 'lit/directives/cache.js';
import { supportTypes, operationIn, artforms } from '../../utilities/profileUtilities';
import { web, address, phone, email, arrowBack } from '../../utilities/icons';
export class AllInSupport extends LitElement {
    static properties = {
        name: { type: String },
        organisation: { type: String },
        profile: { type: String },
        preview: { type: String },
        profileData: { type: Array },
        organisationImage: { type: String },
        organisationImageAlt: { type: String },
        action: { type: String },
        nonce: { type: String },
        restUrl: { type: String },
        hardlinks: { type: Object },
        _currentProfileSidebar: { state: true, type: Object },
        _currentProfile: { state: true, type: String },
    };
    constructor() {
        super();
    }
    async connectedCallback() {
        super.connectedCallback();
        this.eventManager = new EventManager(this);
        this.eventManager.listen(`allin-navigation-${this.name}`, this._updateSidebar.bind(this));
        window.setTimeout(() => {
            this._setSidebar();
        }, 2000);
        cardLinks(this.shadowRoot);
        console.log(this.hardlinks);
    }
    firstUpdated() {
        if (this.profileData && this.profileData.draftInfo) {
            let draft = JSON.parse(this.profileData.draftInfo);
            console.log('Draft data:', draft);
            console.log('Profile data before merging draft:', this.profileData);
            this.profileData = { ...this.profileData, ...draft };
        }
    }
    updated(changedProperties) {
        if (changedProperties.has('profileData')) {
            this._setSidebar();
            if (!this.preview) {
                this.eventManager.emit(`allin-header-${this.name}`, { name: this.name, text: `${this.profileData.name}` });
            }
        }
        cardLinks(this.shadowRoot);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
    }
    /* updated(changedProperties){

    } */
    render() {
        let mobileaside;
        let main = '';
        if (!this.profileData || this.profileData.length == 0) {
            main = html `<allin-loader loading></allin-loader>`;
        }
        else {
            let notice = '';
            if (this.profileData.status == 'NewApplication' || this.profileData.status == 'AwaitingApproval') {
                notice = html `<p class="message">Mae\u2019r rhagolwg hwn yn dal i aros i gael ei gymeradwyo.</p>`;
            }
            let loop = [];
            let image = this.organisationImage;
            if (image) {
                loop.push(html `\n                    <div class="item grid--featured">\n                        <img src="${image}" alt="${this.organisationImageAlt}" />\n                    </div>`);
            }
            let description = this.profileData.description;
            let name = this.profileData.name;
            let text = html `\n                <h2>${name?.value}</h2><allin-markdown-editor readonly value="${description}"></allin-markdown-editor>`;
            let _supportTypes = this.profileData.supportTypes;
            let _artforms = this.profileData.artforms;
            let _operationIn = this.profileData.operationIn;
            _supportTypes = _supportTypes.map(item => {
                let label = supportTypes.find(type => type.name == item)?.label || item;
                return html `<li><a href="${this.hardlinks.listings_support}?supportTypes=${item}">${label}</a></li>`;
            });
            _artforms = _artforms.map(item => {
                let label = artforms.find(type => type.name == item)?.label || item;
                return html `<li><a href="${this.hardlinks.listings_support}?artforms=${item}">${label}</a></li>`;
            });
            _operationIn = _operationIn.map(item => {
                let label = operationIn.find(type => type.name == item)?.label || item;
                return html `<li><a href="${this.hardlinks.listings_support}?operationIn=${item}">${label}</a></li>`;
            });
            mobileaside = html `<div class="mobile-aside">${this._currentProfileSidebar}</div>`;
            main = html `\n                ${notice}\n                <div class="profile">\n                    <div class="image-grid">${loop}</div>\n                    <div class="profile_text">\n                        ${text}\n                        ${_supportTypes.length > 0 ? html `<div class="types"><h3>Math o gymorth</h3><ul>${_supportTypes}</ul></div>` : ''}\n                        ${_artforms.length > 0 ? html `<div class="types"><h3>Ffurfiau celfyddydol a gefnogir</h3><ul>${_artforms}</ul></div>` : ''}\n                        ${_operationIn.length > 0 ? html `<div class="types"><h3>Yn gweithredu yn</h3><ul>${_operationIn}</ul></div>` : ''}\n                    </div>\n                    <aside class="sidebar mobile-sidebar">${mobileaside}</aside>\n                </div>\n            `;
        }
        return html `${cache(main)}`;
    }
    _updateSidebar(e) {
        this._currentProfileSidebar = e.detail.sidebar;
    }
    _handleGoBack() {
        this._currentProfile = '';
        this._currentProfileSidebar = '';
    }
    _selectProfile(profile) {
        this._currentProfile = profile;
    }
    _setSidebar() {
        let loop = [];
        let websiteD = this.profileData.website;
        if (websiteD) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${web}</div>\n                    <div class="icon_text">\n                        <strong>Gwefan:</strong>\n                        <p><a href="${websiteD.value}" target="_blank">${websiteD}</a></p>\n                    </div>\n                </div>`);
        }
        let addressD = [
            this.profileData.address1,
            this.profileData.address2,
            this.profileData.city,
            this.profileData.country,
            this.profileData.postcode
        ];
        if (addressD[0]) {
            loop.push(html `<div class="item grid grid--icon">\n                    <div class="icon">${address}</div>\n                    <div class="text">\n                        <strong>Cyfeiriad:</strong>\n                        <address>\n                        ${addressD.map(item => html `<p>${item}</p>`)}\n                        </address>\n                    </div>\n                </div>`);
        }
        let phoneD = this.profileData.phone;
        if (phoneD) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${phone}</div>\n                    <div class="text">\n                        <strong>Ff\u00F4n:</strong>\n                        <p>${phoneD}</p>\n                    </div>\n                </div>`);
        }
        let emailD = this.profileData.email;
        if (emailD) {
            loop.push(html `<div class="grid grid--icon">\n                    <div class="icon">${email}</div>\n                    <div class="text">\n                        <strong>E-bost mynediad:</strong>\n                        <p>${emailD}</p>\n                    </div>\n                </div>`);
        }
        if (this.preview == "true") {
            this.eventManager.emit(`allin-navigation-${this.name}`, {
                navigation: [[
                        { title: `N\u00F4l i olygu`, url: `#`, id: `organisation-dashboard`, callback: this._handleGoBack.bind(this), icon: 'arrowBack' },
                    ]],
                currentPage: '/',
                sidebar: html `\n                    <div class="sidebar preview">${loop}</div>\n                `
            });
        }
        else {
            this.eventManager.emit(`allin-navigation-${this.name}`, {
                navigation: [],
                currentPage: '/',
                sidebar: html `\n                    <div class="sidebar">\n                        <h2 class="screen-reader-text">Gwybodaeth proffil cymorth</h2>\n                        ${loop}\n                        <div class="return">\n                            <a href="#" @click=${this._handleGoBack}><span aria-hidden="true">${arrowBack}</span>N\u00F4l i chwilio</a>\n                        </div>\n                    </div>\n                `
            });
        }
    }
    _handleGoBack(e) {
        e.preventDefault();
        this.eventManager.emit(`allin-support-go-back-${this.name}`, { hide: true });
    }
    static styles = [
        accessibility,
        grid,
        details,
        css `
        :host{
            width:100%;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            display:grid;
            gap:1rem;
        }
        .small{
            font-size:0.875rem;
        }

        .grid{
            gap:1.5rem;
        }
        h2{
            font-size:1.5rem;
            color:var(--allin-highlight-color,#472961);
        }
        h3{
            color:var(--allin-highlight-color,#472961);
        }
        
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
        }
        .provisions summary{
            padding:1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: flex;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-right:auto;
            margin-bottom:1rem;
            display: flex;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }

        .grid--icon {
            grid-template-columns: 1.6rem 1fr;
            gap: 1.5rem;
            margin-bottom: 1rem;
            width: 100%;
        }

        /** Mobile sidebard to show up only below 999px */
        aside.sidebar.mobile-sidebar{
            display: none;
            padding: 2.5rem 0;
            max-width: 300px;
        }
        .mobile-sidebar .grid--icon {
            margin-bottom: unset;
            border-bottom: 1px solid var(--allin-border-color, #707070);
            padding: 1rem 0;
        }
        .mobile-sidebar .grid--icon svg{
            width: 1.6rem;
            height: auto;
        }
        .mobile-sidebar .grid--icon svg path{
            fill: var(--allin-highlight-color, #472961);
        }
        .mobile-sidebar p{
            margin: 0;
        }
        .mobile-sidebar .grid--icon p strong{
            color: var(--allin-regular-text-color, #1a1a1a);
        }
        .mobile-sidebar a{
            color: var(--allin-text-color, #472961);
            text-decoration: underline;
            font-weight: 600;
            white-space: normal;
            overflow-wrap: break-word;
            word-break: break-word;
            display: inline;
        }
        .mobile-sidebar .return a{
            font-size: 1.25rem;
            font-weight: 700;
        }
        .mobile-sidebar .grid--icon+.item.text {
            padding-top: 1rem;
        }
        .mobile-sidebar .item.text {
            padding: 0 0 1rem;
        }
        .mobile-sidebar .return{
            padding: 0;
            margin-bottom: 2rem;
        }

        p{
            margin-top:0;
        }

        .provisions summary::after {
            right: 1rem;
            top: 1.2rem;
        }

        .types ul{
            display: flex;
            list-style: none;
            padding: 0;
            gap: 1rem;
            flex-wrap: wrap;
            a{
                color: #472961;
                text-decoration-thickness: 0.05em;
                transition: text-decoration-thickness var(--transition) ease, color var(--transition) ease;
                text-underline-offset: 0.25em;
            }
        }

        .grid--featured img {
            height: 6.25rem;
            width: auto;
        }

        @media screen and (max-width: 999px) {
            aside.sidebar.mobile-sidebar{
                display: block;
            }
        }
        `
    ];
}
